import { IonItem, IonLabel, IonSelect, IonSelectOption } from "@ionic/react"
import React from "react"

interface Props {
  value: string
  onChange: (value: string) => void
}

const FormPaymentTerm: React.FC<Props> = props => {
  return (
    <IonItem>
      <IonLabel position="floating">Zahlweise / Abbuchung</IonLabel>

      <IonSelect value={props.value} okText="Wählen" cancelText="Abbrechen" onIonChange={e => props.onChange((e.target as HTMLInputElement).value)}>
        <IonSelectOption value="monthly">Monatlich</IonSelectOption>
        <IonSelectOption value="yearly">Jährlich</IonSelectOption>
      </IonSelect>
    </IonItem>
  )
}

export default FormPaymentTerm
